import React, { useState } from "react";
import { MapPin, AlertTriangle } from "lucide-react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";

export default function LocationStamp({ location, label = "Location", testid }) {
  const [open, setOpen] = useState(false);
  if (!location || location.lat == null || location.lng == null) return null;

  const lat = Number(location.lat);
  const lng = Number(location.lng);
  const coords = `${lat.toFixed(5)}, ${lng.toFixed(5)}`;
  const offSite = !!location.off_site;
  const d = 0.004;
  const bbox = `${lng - d}%2C${lat - d}%2C${lng + d}%2C${lat + d}`;
  const mapSrc = `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${lat}%2C${lng}`;
  const externalLink = `https://www.openstreetmap.org/?mlat=${lat}&mlon=${lng}#map=17/${lat}/${lng}`;

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid={testid}
        className={`inline-flex items-center gap-1 text-xs hover:underline ${offSite ? "text-[hsl(8,54%,42%)] font-medium" : "text-primary"}`}
        title={offSite ? `Off-site — ${location.distance_display} from the park` : `View ${label} on map`}
      >
        {offSite ? <AlertTriangle className="h-3.5 w-3.5" /> : <MapPin className="h-3.5 w-3.5" />}
        {coords}{offSite ? ` · off-site` : ""}
      </button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid={testid ? `${testid}-dialog` : undefined}>
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2"><MapPin className="h-4 w-4" /> {label}</DialogTitle>
          </DialogHeader>
          <div className="space-y-3">
            {offSite && (
              <div className="flex items-center gap-2 text-sm text-[hsl(8,54%,38%)] bg-[hsl(8,60%,96%)] border border-[hsl(8,50%,82%)] rounded-lg px-3 py-2" data-testid={testid ? `${testid}-offsite` : undefined}>
                <AlertTriangle className="h-4 w-4 shrink-0" />
                Captured {location.distance_display} from the caravan park — flagged as off-site.
              </div>
            )}
            <iframe
              title={label}
              src={mapSrc}
              className="w-full h-64 rounded-lg border border-border"
              loading="lazy"
            />
            <div className="flex items-center justify-between text-sm">
              <span className="text-muted-foreground">
                {coords}{location.accuracy ? ` · ±${Math.round(location.accuracy)}m` : ""}
                {location.distance_display ? ` · ${location.distance_display} from park` : ""}
              </span>
              <a href={externalLink} target="_blank" rel="noreferrer" className="text-primary hover:underline">Open in maps</a>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
